<!-- Chat Sidebar area -->
<div class="chat-sidebar bg-white">
    <!-- Sidebar header start -->
    <div class="chat-fixed-search">
      <div class="d-flex align-items-center w-100">
        <div class="input-group input-group-merge ml-1 w-100">
          <div class="input-group-prepend">
            <span class="input-group-text round"><i data-feather="search" class="text-muted"></i></span>
          </div>
          <input
            type="text"
            class="form-control round"
            id="chat-search"
            placeholder="{{ 'BELIVPEDIA.MESSAGES.FILE_SEARCH_INPUT' | translate}}"
            aria-label="Search..."
            aria-describedby="chat-search"
            [(ngModel)]="searchText"
          />
        </div>
      </div>
    </div>
    <!-- Sidebar header end -->
  
    <!-- Sidebar Users start -->
    <div id="users-list" class="chat-user-list-wrapper list-group" >
      <h4 class="chat-list-title">{{ 'BELIVPEDIA.MESSAGES.SOURCES' | translate}}</h4>
      <ng-container *ngIf="(sources | filter: searchText: isEnglish ? 'nameEnglish' : 'name').length; else noResultsChats"></ng-container>
      <ul class="chat-users-list chat-list media-list">
        <li
          *ngFor="let source of sources | filter: searchText: isEnglish ? 'nameEnglish' : 'name'"
          [class.active]="source.name === selectedSource"
          (click)="selectSource(source.name)" data-toggle="tooltip" placement="right"
          ngbTooltip="{{ source.description | translateField: { obj: source, property: 'description' }  }}" container="body"
        >
          <div class="chat-info flex-grow-1">
            <h5 class="mb-0">{{ source.name | translateField: { obj: source, property: 'name' }  }}</h5>
          </div>
        </li>
  
        <ng-template #noResultsChats>
          <li class="no-results" [ngClass]="{ show: (sources | filter: searchText: isEnglish ? 'nameEnglish' : 'name').length <= 0 }">
            <h6 class="mb-0">{{ 'BELIVPEDIA.MESSAGES.SOURCES_NOT_FOUND' | translate}}</h6>
          </li>
        </ng-template>
      </ul>
    </div>
    <!-- Sidebar Users end -->
  </div>
  <!--/ Chat Sidebar area -->
  
